import BenefitPlan from "../../../app/domain/BenefitPlan";
import renderBenefitPlanPage from "../../../infrastructure/renders/BenefitPlanPage/render-benefit-plan-page";
import renderBenefitPlanOnboardingModal from "../../../infrastructure/renders/BenefitPlanOnboardingModal/render-benefit-plan-onboarding-modal";
import { hideModal } from "../../commons/hide-modal";

export default function startBenefitPlanProcess() {
  const benefitPlan = new BenefitPlan({
    id: "",
    employees: [],
    name: "",
  });

  renderBenefitPlanOnboardingModal({
    callback: () => {
      renderBenefitPlanPage({ benefitPlan });
      hideModal();
    },
  });
}
